import React, { useCallback, useState } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Button } from "@amzn/awsui-components-react-v3";
import AddUserModal, { AddUserResult } from "./AddUserModal";
import { FormContextProvider } from "../../forms/formContext";
import { TeamDtoWithBreadcrumb } from "../../layout/subheader/SubHeaderDto";
import { MetricsState } from "../../logging";
import bannerSlice, { DisplayBanner } from "../../banner/bannerSlice";

export interface AddUserProps {
  team: TeamDtoWithBreadcrumb;
  isAuthorized: boolean | undefined;
  metrics: MetricsState;
  reloadPermissionsTable: () => void;
  isLoading: boolean;
}

interface AddUserDispatchProps {
  setBanner: (banner: DisplayBanner | undefined) => void;
}

const AddUser: React.FC<AddUserProps & AddUserDispatchProps> = ({
  team,
  isAuthorized,
  metrics,
  reloadPermissionsTable,
  setBanner,
  isLoading,
}): JSX.Element => {
  const [localChanges, setLocalChanges] = useState<Partial<AddUserResult>>({});
  const [showModal, setShowModal] = useState<boolean>(false);

  const updateLocalChanges = useCallback(
    (_: Partial<AddUserResult>, diff: Partial<AddUserResult>) => {
      setLocalChanges(diff);
    },
    []
  );

  return (
    <React.Fragment>
      <FormContextProvider<Partial<AddUserResult>>
        metrics={metrics}
        formId="addUser-modal"
        onFormValueChange={updateLocalChanges}
      >
        {showModal && (
          <AddUserModal
            team={team}
            metrics={metrics}
            localChanges={localChanges}
            showModal={showModal}
            setShowModal={setShowModal}
            reloadPermissionsTable={reloadPermissionsTable}
            setBanner={setBanner}
          />
        )}
      </FormContextProvider>
      <Button
        data-test-id="add-user-btn"
        onClick={() => {
          setShowModal(true);
          setBanner(undefined);
        }}
        disabled={!isAuthorized || isLoading}
      >
        Add user(s)
      </Button>
    </React.Fragment>
  );
};

const mapDispatchToProperties = (dispatch: Dispatch): AddUserDispatchProps => {
  return {
    setBanner: (banner: DisplayBanner | undefined) => {
      dispatch(bannerSlice.actions.setBanner(banner));
    },
  };
};

export default connect(null, mapDispatchToProperties)(AddUser);
